import { client } from "./supabase";

export const getFotosGaleria = async () => {
  const { data, error } = await client.from("galeria_fotos").select("*").order("created_at", { ascending: false });
  if (error) throw error;
  return data || [];
};

export const uploadFotoGaleria = async (file, { idcliente, idedificio, screen_type, created_by }) => {
  const ext = file.name.split(".").pop().toLowerCase();
  const path = `galeria/${idcliente || "xx"}-${idedificio}-${screen_type}_${Date.now()}.${ext}`;
  const { error: uploadError } = await client.storage.from("galeria").upload(path, file);
  if (uploadError) throw uploadError;
  const { data: urlData } = client.storage.from("galeria").getPublicUrl(path);
  const url = urlData.publicUrl;
  const { data, error: insertError } = await client
    .from("galeria_fotos")
    .insert([{ url, idcliente, idedificio, screen_type, created_by }])
    .select();
  if (insertError) throw insertError;
  return data?.[0];
};

export const deleteFotoGaleria = async (fotoRecord) => {
  const url = new URL(fotoRecord.url);
  const pathMatch = url.pathname.match(/\/storage\/v1\/object\/public\/galeria\/(.+)/);
  if (pathMatch) {
    const storagePath = decodeURIComponent(pathMatch[1]);
    await client.storage.from("galeria").remove([storagePath]);
  }
  const { error } = await client.from("galeria_fotos").delete().eq("id", fotoRecord.id);
  if (error) throw error;
};
